(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evowrap-panel-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evowrap-panel-measurements')) {
    customElements.define('evowrap-panel-measurements', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.widthInput = this.querySelector('[data-panel-width]');
        this.heightInput = this.querySelector('[data-panel-height]');
        this.confirmationInput = this.querySelector('[data-panel-confirmed]');
        this.error = this.querySelector('[data-panel-error]');
        this.sizes = JSON.parse(this.querySelector('[data-panel-sizes]').textContent);
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.form.addEventListener('change', event => {
          if (event.target.name === 'id') this.updateLimits();
        }, { signal });
        this.addEventListener('input', event => {
          if (event.target === this.widthInput || event.target === this.heightInput) this.confirmationInput.checked = false;
          this.validate(this.showErrors);
        }, { signal });
        this.form.addEventListener('invalid', () => {
          this.showErrors = true;
          this.validate(true);
        }, { capture: true, signal });
        this.form.addEventListener('submit', event => {
          this.showErrors = true;
          if (!this.validate(true)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.form.reportValidity();
            return;
          }
          this.widthInput.value = String(Number(this.widthInput.value));
          this.heightInput.value = String(Number(this.heightInput.value));
        }, { capture: true, signal });
        this.updateLimits();
      }
      disconnectedCallback() {
        this.abort?.abort();
      }
      updateLimits() {
        this.confirmationInput.checked = false;
        this.size = this.sizes[this.form.querySelector('[name="id"]').value];
        if (this.size) {
          this.widthInput.max = this.size.width;
          this.heightInput.max = this.size.height;
          this.querySelector('[data-panel-limit]').textContent = this.dataset.limit
            .replace('[width]', this.size.width).replace('[height]', this.size.height);
        }
        const hasMeasurements = this.widthInput.value !== '' || this.heightInput.value !== '';
        this.validate(this.showErrors || hasMeasurements);
      }
      validate(showErrors = false) {
        const inputs = [[this.widthInput, 'width'], [this.heightInput, 'height']];
        let firstError = '';
        for (const [input, dimension] of inputs) {
          const value = Number(input.value);
          let message = '';
          if (input.value === '') message = this.dataset.missing;
          else if (!this.size || !Number.isFinite(value) || value < 0.01) message = this.dataset.invalid;
          else if (value > this.size[dimension]) {
            message = this.dataset[dimension === 'width' ? 'overWidth' : 'overHeight']
              .replace('[max]', this.size[dimension]);
          }
          input.setCustomValidity(message);
          input.setAttribute('aria-invalid', String(Boolean(showErrors && message)));
          if (!firstError && message) firstError = message;
        }
        const confirmationError = this.confirmationInput.checked ? '' : this.dataset.unconfirmed;
        this.confirmationInput.setCustomValidity(confirmationError);
        this.confirmationInput.setAttribute('aria-invalid', String(Boolean(showErrors && confirmationError)));
        if (!firstError) firstError = confirmationError;
        this.error.textContent = showErrors ? firstError : '';
        this.error.hidden = !showErrors || !firstError;
        return !firstError;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
